<template>
    <!-- Order Payment Status-->
    <span v-if="order.hasPendingPayments"
          data-component="OrderPaidStatusLabel"
          class="label label-warning">{{ l('ORDER_PAYMENT_STATUS.PENDING') }}</span>
    <span v-else-if="order.overpaid"
          data-component="OrderPaidStatusLabel"
          class="label label-warning">{{ l('ORDER_PAYMENT_STATUS.OVERPAID') }}</span>
    <span v-else-if="order.fullyPaid"
          data-component="OrderPaidStatusLabel"
          class="label label-success">{{ l('ORDER_PAYMENT_STATUS.FULLY_PAID') }}</span>
    <span v-else-if="order.partiallyPaid"
          data-component="OrderPaidStatusLabel"
          class="label label-warning">{{ l('ORDER_PAYMENT_STATUS.PART_PAID') }}</span>
    <span v-else-if="order.unpaid"
          data-component="OrderPaidStatusLabel"
          class="label label-danger">{{ l('ORDER_PAYMENT_STATUS.UNPAID') }}</span>
</template>

<script>

export default {
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
};
</script>
